import { useSyncExternalStore } from 'react'

/**
 * Band pin requests (GH #2822). The menu that asks closes at once, so the write, its toasts and Undo run in
 * `BandPinHost`, mounted once beside the app's alerts (the Move picker's pattern, #2543).
 */
export interface BandPinRequest {
  /** Increases with every request, so the host handles each once */
  seq: number
  bandId: string
  entityId: string
  action: 'pin' | 'unpin'
}

let current: BandPinRequest | null = null
let seq = 0
const listeners = new Set<() => void>()

const emit = () => {
  for (const listener of listeners) {
    listener()
  }
}

export const requestBandPin = (request: Omit<BandPinRequest, 'seq'>) => {
  seq += 1
  current = { ...request, seq }
  emit()
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const useBandPinRequest = () => useSyncExternalStore(subscribe, () => current)
